import { Box, Button } from '@redbubble/design-system';
import React, { useRef } from 'react';
import { TopicNavItem } from './TopicNavItem/TopicNavItem';
var expandSideMenuTray = function () {
    var _a;
    (_a = document
        .querySelector('[data-testid="ds-header-hamburger-action"]')) === null || _a === void 0 ? void 0 : _a.click();
};
function TopicNavSection(_a) {
    var section = _a.section, onEvent = _a.onEvent;
    var href = section.href, items = section.items, label = section.label;
    return (React.createElement(Box, { display: "flex", flex: "0 0 auto", alignItems: "center", paddingX: "xl", className: "rb-topic-nav__section" },
        React.createElement(Button, { type: "button", href: href || undefined, border: true, onClick: href ? undefined : expandSideMenuTray }, label),
        items.length > 0 && (React.createElement(Box, { display: "flex", alignItems: "center", className: "rb-topic-nav__section-children" }, items.map(function (_a) {
            var Icon = _a.icon, itemLabel = _a.label, active = _a.active, itemHref = _a.href;
            return Icon ? (React.createElement(TopicNavItem, { key: itemHref, label: itemLabel, active: active, Icon: Icon, href: itemHref, onNavItemClick: function () { return onEvent === null || onEvent === void 0 ? void 0 : onEvent({ link_label: itemLabel }); } })) : null;
        })))));
}
export function TopicNav(_a) {
    var config = _a.config, onEvent = _a.onEvent;
    var _b = config !== null && config !== void 0 ? config : {}, topics = _b.topics, products = _b.products;
    var navRef = useRef(null);
    var dragStart = useRef({ pointerId: -1, x: 0, scrollLeft: 0 });
    var didDrag = useRef(false);
    var handlePointerDown = function (event) {
        if (event.button !== 0)
            return;
        var nav = navRef.current;
        if (!nav)
            return;
        dragStart.current = {
            pointerId: event.pointerId,
            x: event.clientX,
            scrollLeft: nav.scrollLeft,
        };
        didDrag.current = false;
    };
    var handlePointerMove = function (event) {
        var nav = navRef.current;
        if (!nav || dragStart.current.pointerId !== event.pointerId)
            return;
        var distance = event.clientX - dragStart.current.x;
        if (!didDrag.current && Math.abs(distance) <= 5)
            return;
        if (!didDrag.current) {
            didDrag.current = true;
            nav.setPointerCapture(event.pointerId);
        }
        nav.scrollLeft = dragStart.current.scrollLeft - distance;
    };
    var stopDragging = function (event) {
        var _a;
        if (dragStart.current.pointerId !== event.pointerId)
            return;
        dragStart.current.pointerId = -1;
        if ((_a = navRef.current) === null || _a === void 0 ? void 0 : _a.hasPointerCapture(event.pointerId)) {
            navRef.current.releasePointerCapture(event.pointerId);
        }
    };
    var handleDragStart = function (event) {
        event.preventDefault();
    };
    var handleClickCapture = function (event) {
        if (didDrag.current) {
            event.preventDefault();
            event.stopPropagation();
            didDrag.current = false;
        }
    };
    return (React.createElement(Box, { ref: navRef, element: "nav", display: "flex", alignItems: "stretch", paddingY: "xs", className: "rb-topic-nav", "aria-label": "Topic navigation", onPointerDown: handlePointerDown, onPointerMove: handlePointerMove, onPointerUp: stopDragging, onPointerCancel: stopDragging, onDragStart: handleDragStart, onClickCapture: handleClickCapture },
        topics && React.createElement(TopicNavSection, { section: topics, onEvent: onEvent }),
        products && React.createElement(TopicNavSection, { section: products, onEvent: onEvent })));
}
